export enum AlertSurgeMetricEnum {
    MENTION_VOLUME = 'MENTION_VOLUME',
    IMPRESSIONS = 'IMPRESSIONS',
    SENTIMENT = 'SENTIMENT'
}

